import type { CookieConsentConfiguration } from "@/types/cookie-consent-configuration";

export const defaultConfiguration = {
  autoClearCookies: true,
  autoShow: false,
  categories: {
    analytics: {
      enabled: true,
      readOnly: false,
    },
    necessary: {
      enabled: true,
      readOnly: true,
    },
  },
  cookie: {
    expiresAfterDays: 180,
    name: "_cc-cookie",
    path: "/",
    sameSite: "Strict",
    secure: true,
    useLocalStorage: false,
  },
  disablePageInteraction: false,
  hideFromBots: true,
  language: {
    autoDetect: "browser",
    default: "en",
    rtl: "ar",
    translations: {
      en: {
        consentModal: {
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          description:
            "Our site uses scripts (e.g. cookies) to collect and store data such as personal identifiers (IP address, session details) and browsing activity. This helps us deliver content, ensure security, enhance user experience, and support marketing. You can reject non-essential cookies or adjust your preferences by clicking here.",
          showPreferencesBtn: "Manage Individual preferences",
          title: "Cookie preferences",
        },
        preferencesModal: {
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          closeIconLabel: "Close modal",
          savePreferencesBtn: "Accept current selection",
          sections: [],
          title: "Manage cookie preferences",
        },
      },
    },
  },
  manageScriptTags: true,
} satisfies CookieConsentConfiguration;
